var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7466 5.63332C13.0466 2.55332 10.3599 1.16666 7.99994 1.16666C7.99994 1.16666 7.99994 1.16666 7.99327 1.16666C5.63994 1.16666 2.94661 2.54666 2.24661 5.62666C1.46661 9.06666 3.57328 11.98 5.47994 13.8133C6.18661 14.4933 7.09328 14.8333 7.99994 14.8333C8.90661 14.8333 9.81328 14.4933 10.5133 13.8133C12.4199 11.98 14.5266 9.07332 13.7466 5.63332ZM7.99994 8.97332C6.83994 8.97332 5.89994 8.03332 5.89994 6.87332C5.89994 5.71332 6.83994 4.77332 7.99994 4.77332C9.15994 4.77332 10.0999 5.71332 10.0999 6.87332C10.0999 8.03332 9.15994 8.97332 7.99994 8.97332Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationTf);
export default __webpack_public_path__ + "static/media/icon_locationTF.0145a4c8a19855a58586bd632e24a16e.svg";
export { ForwardRef as ReactComponent };